import * as Exit from 'effect/Exit';
import * as Schema from 'effect/Schema';
export * from 'effect/Schema';
/**
 * A field that may be absent or explicitly `undefined`, decoded to `undefined`
 * either way.
 *
 * The default is built with `Exit.succeed` rather than `Effect.succeed`. An
 * `Exit` is an `Effect` — `Exit.Proto` extends it — and `withDecodingDefault`
 * accepts it, but it arrives without `effect/Effect`, which is two hundred
 * kilobytes and was being downloaded by every session for this one call.
 * `Schema.test.ts` decodes the same shapes through both and compares.
 */
export const UndefinedOrFromOptional = (schema) => Schema.UndefinedOr(schema).pipe(Schema.withDecodingDefault(Exit.succeed(undefined)));
//# sourceMappingURL=Schema.js.map